import { jsxs as d, jsx as l } from "react/jsx-runtime";
const c = (e) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...e,
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#thumb_down-filled_svg__a)", children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentcolor",
          fillRule: "evenodd",
          d: "M16.23 3a2.78 2.78 0 0 1 2.552 1.662l2.914 6.673c1.06 2.423-.76 5.066-3.375 5.066h-2.029l.594 2.81.002.007c.156.768-.08 1.56-.646 2.115l-.007.006a2.35 2.35 0 0 1-3.286-.02 1 1 0 0 1-.09-.102l-3.661-4.808a2.74 2.74 0 0 1-.762-1.893V5.753C8.436 4.219 9.706 3 11.224 3zM4.788 3c1.517 0 2.788 1.22 2.788 2.754v7.016c0 1.535-1.27 2.754-2.788 2.754S2 14.305 2 12.77V5.754C2 4.22 3.27 3 4.788 3",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "thumb_down-filled_svg__a", children: /* @__PURE__ */ l("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }) })
    ]
  }
);
export {
  c as default
};
